import { render, staticRenderFns } from "./AccountApplicationsList.vue?vue&type=template&id=0983da44&scoped=true"
import script from "./AccountApplicationsList.vue?vue&type=script&lang=js"
export * from "./AccountApplicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983da44",
  null
  
)

export default component.exports